import { createSelector } from 'reselect';

export default createSelector(
  state => state.channels,
  ({
    error,
    fulfilledTimeStamp,
    isError,
    isFetching,
    isLoading,
    isSuccess,
    isUninitialized,
    rehydrated,
    startedTimeStamp,
  }) => ({
    error,
    fulfilledTimeStamp,
    isError,
    isFetching,
    isLoading,
    isSuccess,
    isUninitialized,
    rehydrated,
    startedTimeStamp,
  }),
);
